module.exports = __webpack_public_path__ + "img/waterfall-2.68a30c2.png";